/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be2e0f32559f08f5bfd98787a43c1619>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ChildWorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/child-work-items
 * Usage guidance:
 * Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ChildWorkItemsIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "ChildWorkItemsIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M8.5 13.5h5V11h-5zm0-7h5V4h-5zm6.5.25C15 7.44 14.44 8 13.75 8h-5.5C7.56 8 7 7.44 7 6.75V6H2.5v5a.5.5 0 0 0 .5.5h4v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-5.5C7.56 15 7 14.44 7 13.75V13H3a2 2 0 0 1-2-2V1h1.5v3.5H7v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ChildWorkItemsIcon.displayName = 'ChildWorkItemsIcon';
var _default = exports.default = ChildWorkItemsIcon;